<template>
  <div class="content">
    <el-tree
      class="tree"
      ref="tree"
      node-key="uuid"
      :data="treeData"
      :props="defaultProps"
      default-expand-all
    >
      <div class="custom-tree-node" slot-scope="{ data }">
        <div @click="toDiv(data.uuid)">{{ data.text }}</div>
        <!-- <a class="anchor" :href="`#${data.uuid}`">
          {{ data.text }}
        </a> -->
      </div>
    </el-tree>
    <div v-html="content" class="markdown-body html-content" style=""></div>
  </div>
</template>

<script>
// import 'github-markdown-css'
import hljs from 'highlight.js'
import 'highlight.js/styles/atom-one-light.css'
import $ from 'jquery'
import marked from 'marked'
import { getDoc } from '@/api/post.js'
export default {
  name: 'MarkdownView',
  data() {
    return {
      treeData: [],
      defaultProps: {
        label: 'text',
        children: 'children'
      },
      textData:
        '# JavaScript高级程序设计\n## 内容简介\n   本书是JavaScript经典图书的新版。第4版全面、深入地介绍了JavaScript开发者必须掌握的前端开发技术，涉及JavaScript的基础特性和高级特性。书中详尽讨论了JavaScript的各个方面，从JavaScript的起源开始，逐步讲解到新出现的技术，其中重点介绍ECMAScript和DOM标准。在此基础上，接下来的各章揭示了JavaScript的基本概念，包括类、期约、迭代器、代理，等等。另外，书中深入探讨了客户端检测、事件、动画、表单、错误处理及JSON。本书同时也介绍了近几年来涌现的重要新规范，包括Fetch API、模块、工作者线程、服务线程以及大量新API。\n## 作者简介\n马特·弗里斯比（Matt Frisbie），Stealth Startup公司CTO，曾担任谷歌公司软件工程师，精通前端技术，拥有十余年Web开发经验，除本书外另著有AngularJS等前端主题图书。毕业于伊利诺伊大学厄巴纳-尚佩恩分校。\n## 目录\n### 第 1章　什么是JavaScript 1\n#### 1.1　简短的历史回顾 1\n#### 1.2　JavaScript实现 2\n#### 1.3　JavaScript版本 9\n#### 1.4　小结 10\n### 第2章　HTML中的JavaScript 11\n#### 2.1　script元素 11\n#### 2.2　行内代码与外部文件 18\n#### 2.3　文档模式 18\n#### 2.4　noscript元素 19\n测试代码\n``` javascript\nvar a = 1;\n\nfunction fun(){\n  console.log(11111)\n}\nfun()\nconosole.log(a)\n```\n\n#### 2.5　小结 20\n### 第3章　语言基础 21\n#### 3.1　语法 21\n#### 3.2　关键字与保留字 23\n#### 3.3　变量 24\n#### 3.4　数据类型 30\n#### 3.5　操作符 56\n#### 3.6　语句 73\n#### 3.7　函数 80\n#### 3.8　小结 82\n### 第4章　变量、作用域与内存 83\n#### 4.1　原始值与引用值 83\n#### 4.2　执行上下文与作用域 87\n#### 4.3　垃圾回收 94\n#### 4.4　小结 101 > [!NOTE]> **注意**：mdmdt.css 文件中包含了亮色和暗色两者主题，会跟随系统模式自动切换亮暗主题。'
    }
  },
  created() {
    this.$nextTick(() => {
      this.getDoc()
    })
  },
  computed: {
    content() {
      const rendererMD = new marked.Renderer()
      marked.setOptions({
        renderer: rendererMD,
        highlight: function (code) {
          return hljs.highlightAuto(code).value
        },
        pedantic: false,
        gfm: true,
        tables: true,
        breaks: false,
        sanitize: false,
        smartLists: true,
        smartypants: false,
        xhtml: false
      })
      return marked(this.textData)
    }
  },
  methods: {
    getDoc() {
      getDoc()
        .then((res) => {
          console.log(res)
          this.textData = res.content
        })
        .then(() => {
          this.getCatalog()
        })
    },
    // 根据内容获取目录
    getCatalog() {
      const h = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']
      const elements = $(':header')
      const hElements = []
      for (const key of elements) {
        if (h.indexOf(key.localName) > -1) {
          let text
          if (key.children && key.children.length) {
            text = this.getText(key.children)
          } else {
            text = key.innerHTML
          }
          hElements.push({
            hLevel: parseInt(key.localName[1]),
            text,
            id: key.localName,
            uuid: key.id
          })
        }
      }
      // console.log('hElements:', hElements)
      const result = this.toTree(hElements)
      this.treeData = result

      // 目录默认选中第一个
      this.$nextTick(() => {
        if (!result) return
        this.$refs.tree.setCurrentKey(result[0].uuid)
      })
      // console.log('result:', result)
    },
    toTree(flatArr) {
      const tree = []
      const copyArr = flatArr.map(function (item) {
        return item
      })

      // 根据指定级别查找该级别的子孙级，并删除掉已经查找到的子孙级
      const getChildrenByLevel = function (currentLevelItem, arr, level) {
        if (!currentLevelItem) {
          return
        }
        // 将level值转成负数，再进行比较
        const minusCurrentLevel = -currentLevelItem.hLevel
        const children = []
        for (let i = 0, len = arr.length; i < len; i++) {
          const levelItem = arr[i]
          if (-levelItem.hLevel < minusCurrentLevel) {
            children.push(levelItem)
          } else {
            // 只找最近那些子孙级
            break
          }
        }
        // 从数组中删除已经找到的那些子孙级，以免影响到其他子孙级的查找
        if (children.length > 0) {
          arr.splice(0, children.length)
        }
        return children
      }

      const getTree = function (result, arr, level) {
        // 首先将数组第一位移除掉，并添加到结果集中
        let currentItem = arr.shift()

        currentItem.level = level
        result.push(currentItem)
        while (arr.length > 0) {
          if (!currentItem) {
            return
          }
          // 根据当前级别获取它的子孙级
          const children = getChildrenByLevel(currentItem, arr, level)
          // 如果当前级别没有子孙级则开始下一个
          if (children.length === 0) {
            currentItem = arr.shift()
            currentItem.level = level
            if (currentItem) {
              result.push(currentItem)
            }
            continue
          }
          currentItem.children = []
          // 查找到的子孙级继续查找子孙级
          getTree(currentItem.children, children, level + 1)
        }
      }
      getTree(tree, copyArr, 1)
      return tree
    },
    getText(arr) {
      let result = null
      if (!arr.length) return
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].children && arr[i].children.length) {
          result = this.getText(arr[i].children)
        } else {
          result = arr[i].innerHTML
        }
      }

      return result
    },
    toDiv(uuid) {
      document.getElementById(uuid).scrollIntoView({
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
/* @import 'github-markdown-css'; */

.content {
  width: 100%;
  display: flex;
  /* padding: 30px; */
  overflow: hidden;
  /* height: 100vh; */
  /* background-color:white; */
  background-color: rgb(0, 37, 60);
  padding: 0;
  margin: auto;
  margin-top: 10px;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);
}

.tree {
  margin-right: 15px;
  overflow-y: auto;
  width: 230px;
  flex-shrink: 0;
  background-color: rgb(0, 37, 50);
  padding: 0;
  margin: 0;
  box-shadow: 0px 1px 2px rgb(0, 0, 0);
}

.html-content {
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 30px;
  color: #edaf93;
}
/deep/.html-content a {
  color: #fefa99;
  text-decoration: none;
}
/deep/.html-content a:hover {
  text-decoration: underline;
}
/deep/.html-content h2 {
  text-align: center;
  font-size: 50px;
  margin-top: 20px;
  margin-bottom: 20px;
}
/deep/.html-content h4 {
  margin-top: 20px;
  margin-bottom: 20px;
  /* text-align: center; */
  font-size: 30px;
  /* margin-left: 30px; */
  margin-left: 1%;
}
/deep/ .html-content pre code {
  display: block;
  padding: 1em;
  background-color: #ffffff;
  color: #333;
  overflow-x: auto;
  border-radius: 8px;
  font-family: Consolas, 'Courier New', monospace;
  line-height: 1.5;
  width: 93%;
  margin: auto;
  margin-top: 7px;
  box-shadow: 0px 1px 10px #edaf93;
}
/deep/ p {
  width: 98%;
  display: block;
  /* border: red 1px solid; */
  /* margin-left: 30px; */
  margin: auto;
  margin-top: 16px;
  /* background-color: aqua; */
  /* border: aqua solid 1px; */
}
/deep/ p img {
  display: block;
  margin: auto;
  min-width: 98%;
  max-width: 98%;
  margin-top: -7px;
  box-shadow: 0px 1px 10px rgb(0, 0, 0);
  border-radius: 8px;
}
/deep/pre {
  margin-top: 0;
}

/* 滚动条修改 */
/* 针对整个页面的滚动条 */
::-webkit-scrollbar {
  width: 7px; /* 修改滚动条宽度 */
  height: 7px; /* 水平滚动条的高度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f1f1f1; /* 轨道背景颜色 */
  border-radius: 10px; /* 轨道圆角 */
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #c0c4cc; /* 滑块颜色 */
  border-radius: 10px; /* 滑块圆角 */
}

/* 当滑块悬停或激活时 */
::-webkit-scrollbar-thumb:hover {
  background: #8894b3; /* 滑块悬停时的颜色 */
}

/* 当滑块处于激活状态时 */
::-webkit-scrollbar-thumb:active {
  background: #606266; /* 滑块激活时的颜色 */
}
</style>
